import { useQuery } from '@tanstack/react-query'
import { fetchSeasons } from '@/api/seasons'

// Seasons data is relatively static, cache for 10 minutes
const STALE_TIME = 10 * 60 * 1000

export function useSeasons() {
  return useQuery({
    queryKey: ['seasons'],
    queryFn: fetchSeasons,
    staleTime: STALE_TIME,
  })
}
